import React from "react";

// Borders first, shadows sparingly (design system §7).
const Card = ({
  as: Tag = "div",
  padded = true,
  hoverable = false,
  elevated = false,
  className = "",
  children,
  ...props
}) => (
  <Tag
    className={`rounded-md border border-border bg-surface ${
      elevated ? "shadow-card" : ""
    } ${
      hoverable ? "transition-shadow hover:shadow-card-hover" : ""
    } ${padded ? "p-5 md:p-6" : ""} ${className}`}
    {...props}
  >
    {children}
  </Tag>
);

export default Card;
